
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as geoM2DVAr3fJfezoTJ2uZHSFLeZx8hz_Pt9deHmZW23OVYMeta } from "/opt/build/repo/app/pages/geo.vue?macro=true";
import { default as flowxsHF9P64_HRe9QHKCZ_QZW1srdFBTA13MxrvviQDmmYMeta } from "/opt/build/repo/app/pages/flow.vue?macro=true";
import { default as testS_oKeuDVuNgRYMeNBvXBdMwh2a0VzU9qYXGdVPk9UikMeta } from "/opt/build/repo/app/pages/test.vue?macro=true";
import { default as indexDRlpF_iz5XUgkm6d_USMrrBnrDkRhW19uzui_n1MZF0Meta } from "/opt/build/repo/app/pages/index.vue?macro=true";
import { default as mobile7btB72TxH4P_0GZi5P6VNRvNHYJBETG0WWVAlQ9JR6IMeta } from "/opt/build/repo/app/pages/mobile.vue?macro=true";
import { default as _91id_93RwQP0YM_4YvFc0_wt26NeabM0HAufLUxt21gIUYasP4Meta } from "/opt/build/repo/app/pages/bydonors/[id].vue?macro=true";
import { default as _91id_93a6XmaB0Q1m81M3jorcldbBweaLG1h2otiFNwIcrXxwwMeta } from "/opt/build/repo/app/pages/recipients/[id].vue?macro=true";
export default [
  {
    name: "geo",
    path: "/geo",
    component: () => import("/opt/build/repo/app/pages/geo.vue")
  },
  {
    name: "flow",
    path: "/flow",
    component: () => import("/opt/build/repo/app/pages/flow.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/build/repo/app/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/app/pages/index.vue")
  },
  {
    name: "mobile",
    path: "/mobile",
    meta: mobile7btB72TxH4P_0GZi5P6VNRvNHYJBETG0WWVAlQ9JR6IMeta || {},
    component: () => import("/opt/build/repo/app/pages/mobile.vue")
  },
  {
    name: "bydonors-id",
    path: "/bydonors/:id()",
    component: () => import("/opt/build/repo/app/pages/bydonors/[id].vue")
  },
  {
    name: "recipients-id",
    path: "/recipients/:id()",
    component: () => import("/opt/build/repo/app/pages/recipients/[id].vue")
  }
]